import '../../sass/plugins/our_partners.scss';
import { LARGE_SCREEN, MEDIUM_SCREEN, EXTRA_SMALL_SCREEN } from '../consts';

$(() => {
  const partnersCount = $('.slide').length;
  const nextArrow = $('.secondary-navigator#partners-carousel-next-arrow');
  const prevArrow = $('.secondary-navigator#partners-carousel-prev-arrow');
  $('.partner-logos').slick({
    slidesToShow: partnersCount > 4 ? 4 : partnersCount,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    pauseOnHover: false,
    nextArrow,
    prevArrow,
    responsive: [
      {
        breakpoint: LARGE_SCREEN,
        settings: {
          slidesToShow: partnersCount > 3 ? 3 : partnersCount,
        },
      },
      {
        breakpoint: MEDIUM_SCREEN,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: EXTRA_SMALL_SCREEN,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});
